import addOneLog from "features/panelManagement/logging/actions/set.addOneLog";
import batchOperations from "services/firebase/batchOperations";
import { AppThunk } from "services/redux/rootReducer";
import { Product } from "../../types/product";

const removeManyProducts =
    (ids: Product["id"][]): AppThunk<Promise<void>> =>
    async (dispatch) => {
        await batchOperations(async (batch, db, batchedIds) => {
            await Promise.all(
                batchedIds.map(async (id) => {
                    const docRef = db.collection("products").doc(id);
                    const subCollectionRef = docRef.collection("tables");

                    const tableBatch = db.batch();

                    const querySnapshot = await subCollectionRef.get();

                    querySnapshot.docs.map((docRef) =>
                        tableBatch.delete(docRef.ref)
                    );

                    await tableBatch.commit();

                    batch.delete(docRef);
                })
            );
        }, ids);

        dispatch(
            addOneLog({
                eventInfo: {
                    description: `Removed product(s) with id(s) ${ids.join(
                        ", "
                    )}`,
                },
            })
        );

        return;
    };

export default removeManyProducts;
